import React from "react";
import { FaShieldAlt, FaSearch, FaHeadset } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";
import "./style.css";

const FeaturesSection = () => {
  const { t } = useTranslation();
  const features = [
    {
      icon: <FaShieldAlt size={24} color="#fff" />,
      title: t("features.title1"),
      description: t("features.desc1"),
      bgColor: "#4CAF50",
    },
    {
      icon: <FaSearch size={24} color="#fff" />,
      title: t("features.title2"),
      description: t("features.desc2"),
      bgColor: "#FF9800",
    },
    {
      icon: <FaHeadset size={24} color="#fff" />,
      title: t("features.title3"),
      description: t("features.desc3"),
      bgColor: "#2196F3",
    },
  ];
  return (
    <div className="container-fluid p-0 optimize-visibility">
      <div className="features-area">
        <div className="px-3 py-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="w-100 mb-4 px-3"
              style={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
              }}
            >
              <div className="d-flex align-items-center py-3">
                <div
                  className="d-flex justify-content-center align-items-center rounded-circle flex-shrink-0"
                  style={{
                    width: "60px",
                    height: "60px",
                    backgroundColor: feature.bgColor,
                  }}
                >
                  {feature.icon}
                </div>
                <div className="ms-3 flex-grow-1">
                  <h2 style={{ fontSize: "20px", fontWeight: "bold", margin: "0 0 4px 0" }}>
                    {feature.title}
                  </h2>
                  <p className="mb-0" style={{ fontSize: "14px", color: "#6c757d" }}>
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default FeaturesSection;
